import React from 'react';
import PropTypes from 'prop-types';

class ArticleLeadCaption extends React.PureComponent {
  render() {
    const s = this.props.styleObj;
    const { imgCaption, videoCaption, isMspArticle } = this.props;
    const stripHTML = htmlString => htmlString.replace(/<[^>]*>/g, '');
    let imgCaptionJSX = (
      <div className={`${s.caption} img_cptn`}>
        <span
          title={stripHTML(imgCaption)}
          dangerouslySetInnerHTML={{ __html: imgCaption }}
        />
        <div />
      </div>
    );
    if (isMspArticle) {
      imgCaptionJSX = (
        <h2 className={`${s.caption}`} style={{ fontWeight: 'normal' }}>
          {imgCaption}
        </h2>
      );
    }

    return (
      <React.Fragment>
        {videoCaption &&
          videoCaption.length && (
            <div className={`${s.caption} img_cptn`}>
              <span
                title={stripHTML(videoCaption)}
                dangerouslySetInnerHTML={{ __html: videoCaption }}
              />
            </div>
          )}
        {imgCaption && imgCaption.length && imgCaptionJSX}
      </React.Fragment>
    );
  }
}

ArticleLeadCaption.propTypes = {
  imgCaption: PropTypes.string,
  videoCaption: PropTypes.string,
  styleObj: PropTypes.shape({}).isRequired,
  isMspArticle: PropTypes.bool,
};

ArticleLeadCaption.defaultProps = {
  imgCaption: '',
  videoCaption: '',
  isMspArticle: '',
};

export default ArticleLeadCaption;
